/**
 * In-memory cache for opened chat rooms (active + archived) so revisiting a room
 * can restore messages and related UI without calling get-message again.
 */
const store = new Map();

function cacheKey(roomId, isArchived) {
  return `${String(roomId)}::${isArchived ? "arch" : "act"}`;
}

/**
 * @param {string} roomId
 * @param {boolean} isArchived
 * @returns {{
 *   messages: unknown[],
 *   assignedAgentImage: string | null,
 *   selectUserMerge: Record<string, unknown>,
 *   selectUserPatch?: Record<string, unknown>,
 *   customerData: unknown[],
 * } | null}
 */
export function getOpenRoomCache(roomId, isArchived) {
  if (roomId == null || roomId === "") return null;
  return store.get(cacheKey(roomId, isArchived)) ?? null;
}

export function setOpenRoomCache(roomId, isArchived, partial) {
  if (roomId == null || roomId === "") return;
  const key = cacheKey(roomId, isArchived);
  const prev = store.get(key) || {};
  store.set(key, { ...prev, ...partial });
}

export function mergeOpenRoomCache(roomId, isArchived, partial) {
  setOpenRoomCache(roomId, isArchived, partial);
}

/** Drop one room (both keys) or clear everything when roomId omitted. */
export function clearOpenRoomCache(roomId) {
  if (roomId == null || roomId === "") {
    store.clear();
    return;
  }
  store.delete(cacheKey(roomId, false));
  store.delete(cacheKey(roomId, true));
}
